import React, { useState, useEffect } from "react";
import { useAuth } from "../AuthContext";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import axios from "axios";
import "./Invoices.css";
import { FaFilePdf } from "react-icons/fa";

const Invoices = () => {
  const { logout } = useAuth();
  const navigate = useNavigate(); // Initialize useNavigate
  const [invoices, setInvoices] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { isLoggedIn, mobile } = useAuth();

  useEffect(() => {
    if (isLoggedIn && mobile) {
      axios
        .get(`${process.env.REACT_APP_API_URL}/api/invoices/${mobile}`, {
          withCredentials: true,
        })
        .then((response) => {
          setInvoices(response.data);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching invoices:", error);
          setIsLoading(false);
        });
    }
  }, [isLoggedIn, mobile]);

  const handleDownloadPdf = async (mobile, invoiceNumber, date) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/invoices/pdf`,
        {
          params: { mobile, invoiceNumber, date },
          withCredentials: true,
          responseType: "blob", // Important to handle binary response data
        }
      );

      // Create a Blob from the PDF Stream
      const file = new Blob([response.data], { type: "application/pdf" });

      // Build a URL from the file
      const fileURL = URL.createObjectURL(file);

      // Trigger the download
      const link = document.createElement("a");
      link.href = fileURL;
      link.download = `${invoiceNumber}.pdf`; // Name the download file
      document.body.appendChild(link);
      link.click();
      link.remove(); // Clean up the DOM
    } catch (error) {
      console.error("Error downloading PDF:", error);
      alert("Failed to download PDF. Please try again.");
    }
  };

  // Invoices.js
  const handleLogout = () => {
    axios
      .post(`${process.env.REACT_APP_API_URL}/logout`)
      .then((response) => {
        if (response.data.success) {
          logout(); // Update frontend state
          navigate("/login"); // Redirect to login page
        } else {
          alert("Logout failed. Please try again.");
        }
      })
      .catch((error) => {
        console.error("Logout error:", error);
        alert("Logout failed. Please try again.");
      });
  };

  const formatDate = (date) => {
    const d = new Date(date);
    let month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };

  return (
    <div className="invoices-page">
      {/* <div className="logout-container">
        <button onClick={handleLogout} className="logout-button">Logout</button>
      </div> */}
      <div className="invoices-container">
        {isLoading ? (
          <p>Loading invoices...</p>
        ) : invoices.length > 0 ? (
          invoices.map((invoice) => (
            <div key={invoice.id} className="invoice-card">
              <div className="invoice-details">
                <h3>{invoice.invoice_number}</h3>
                <p>Date: {new Date(invoice.date).toLocaleDateString()}</p>
                <p>Value: ₹{invoice.value.toLocaleString()}</p>
              </div>
              <button
                className="pdf-download-button"
                onClick={() =>
                  handleDownloadPdf(
                    mobile,
                    invoice.invoice_number,
                    invoice.date
                  )
                }
              >
                <FaFilePdf size={20} />
              </button>
            </div>
          ))
        ) : (
          <p>There are no invoices yet for you.</p>
        )}
      </div>
    </div>
  );
};

export default Invoices;
